'use client';

import { Anchor } from '@components/common';
import { cn } from '@utils/cn';

interface CandidateTagProps {
  label: string;
  href?: string;
  className?: string;
  onClick?: () => void;
}

/**
 * @description Tag badge for candidate sidebar cards.
 * Mirrors the visual design of the my-jobs Tag component and uses an Anchor
 * so the URL is visible on hover. Lives in its own file so candidate tags can
 * evolve independently of company job card tags.
 */
export const CandidateTag = ({
  label, href, className, onClick,
}: CandidateTagProps) => (
  <Anchor
    href={href}
    styling="none"
    className={cn(
      'flex gap-1 rounded-full border border-[#F0F2F4] bg-surface px-4 py-1.5 text-sm hover:shadow-none',
      className,
    )}
    onClick={onClick ? (e) => { e.preventDefault(); e.stopPropagation(); onClick(); } : (e) => { e.stopPropagation(); }}
  >
    {label}
  </Anchor>
);
